import { useRef, useState } from "react"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../../HumanResource/Work/Task/styled"
import SvgIcon from "src/components/SvgIcon"
import { message } from "antd"
import ModalCreate from "../SimWarehouse/Modal/ModalCreate"
import { InputSearchStyle } from "../../Setting/common/styled"

import STORAGE from "src/lib/storage"
import ModalCreateData from "../DataProposal/Modal/ModalCreateData"
import DataEntry from "./components/DataEntry"
import WarehouseService from "src/services/WarehouseService";

const DataWarehouseIn = props => {
  const [tab, setTab] = useState("1")
  const [openModalCreate, setOpenModalCreate] = useState(false)
  const [activeKey, setActiveKey] = useState("pending")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filter, setFilter] = useState({})

  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: 2,
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status_order: "505",
    },
    reject: {
      type: "reject",
      name: "Từ chối",
      status_order: "515",
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status_order: "501",
    },
  }
  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };

  // const items = Object.keys(Tabs).map(key => ({
  //   key,
  //   label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  //   children: [
     
    
  //   ],
  // }))
  const handleExportExcel = async () => {
    try {
      const response = await WarehouseService.exportWareHouseData({
        type : "1",
        supplier_id: filter.supplier_id ?? null,
        network_id: filter.network_id ?? null,
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "Danh_sach_kho_data.xlsx")

        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#005F90",
              margin: 0,
            }}
          >
            KHO DATA
          </h3>

          <div>
            <Button btnType="primary1" onClick={handleExportExcel}>
              <span>Xuất Excel</span>
            </Button>
          </div>
        </div>
      </div>
      <WrapperStyle>
        <ToolBarStyle>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              {/* <TabsCustom
                onChange={activeKey => setActiveKey(activeKey)}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
                destroyInactiveTabPane={true}
                scroll={{ x: true }}
              /> */}
              
                <DataEntry 
                  setFilter={setFilter}
                  filter={filter}  />,
            </StyleTabsCustom>
          </div>
        </ToolBarStyle>
      </WrapperStyle>

      <ModalCreateData
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSubmit={(values) => {
          setIsModalOpen(false);
          // fetchUsers();
        }}
      />
    </div>
  )
}

export default DataWarehouseIn
